import { TypeRepository } from '@src/main/modules/parameters/domain/issues/type.repository';
import { createTypeHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/TypeHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useType = (id: string) => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<TypeRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createTypeHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  return useQuery({
    queryKey: ['type', id],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await repository.findById(id);
    },
    enabled: !!repository && !!id,
    staleTime: 1000 * 60 * 5,
  });
};
